import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../shared/core2Config";
import { WarehouseLayoutNodeContainerLinkModel } from "../../../../../models/aggregates/warehouse/index";

@Injectable({ providedIn: "root" })
export class WarehouseLayoutNodeContainerLinkService extends BaseApiTemplateService<WarehouseLayoutNodeContainerLinkModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/layout-container-links/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/layout-container-links/backoffice-ep";
    this.httpClient = http;
  }
}
